import * as React from 'react'

type TableTextRowProps = {
  children?: React.ReactNode
  icon?: React.ReactNode
  size?: 'small' | 'medium'
  bolder?: boolean
}

const ViolationsListRowItem: React.FC<TableTextRowProps> = ({
  children,
  icon,
}) => {
  return (
    <td
      className={`tw-cursor-pointer tw-py-3.5 tw-pl-2.5 tw-pr-3 tw-text-content-base tw-opacity-90`}
    >
      <div
        className={`tw-flex tw-items-center tw-gap-2 tw-text-nowrap tw-text-sm`}
      >
        {icon && (
          <span className="tw-flex-shrink-0 tw-text-content-base">{icon}</span>
        )}
        {children}
      </div>
    </td>
  )
}
export default ViolationsListRowItem
